import axios, { AxiosError, type AxiosResponse } from 'axios';
import {deCodeToken} from '@/stores/auth';

// 👇接口返回的数据结构
export interface APIResponse<T = any> {
    data?: T;
    message?: string;
    status?: boolean;
}

export interface APIEorrorResponse<T = any> {
    error?: T;
    message?: string;
    status?: boolean;
}
interface RequestConfig {
    showTips?: boolean; // 值为 false 则不弹出提示
    headers?: object;
}

export const usePublicApi = (
    subPath: string = '',
    oSetting: RequestConfig={}, 
) => {
    const baseURL = `/api/${subPath}`;
    const showTips = oSetting.showTips ?? true;
    const $i18n = useNuxtApp().$i18n;
    // 💥 Authorization 说明 2024.01.24 17:57:42 星期三
    // 后端同事 Joe： 前端http请求加上请求头 Authorization，值为登录时返回的token
    // 后端http服务 根据这个请求头来判断用户是否登录。
    // 如果前台请求需要登录的http接口，没带这个头或者token失效 ，后端返回401状态码
    const oFinalSetting = {
        baseURL,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': deCodeToken(),
            ...(oSetting?.headers || {}),
        },
    };
    const api = axios.create(oFinalSetting);
    // 👇请求拦截器
    api.interceptors.request.use(
        // Do something before request is sent
        (config) => {
            if (oFinalSetting.headers['Content-Type'] == 'application/json') {
                const locale = $i18n.locale.value || 'en';
                config.params = { 
                    ...(config.params || {}),
                    locale, // 后端人员表示： “所有 API请求都带上” ，—— 2024.05.23 19:0:59 星期四  
                };
            }
            return config;
        },
        // Do something with request error
        (error) => {
            return Promise.reject(error);
        },
    );
    // 👇响应拦截器
    api.interceptors.response.use(
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        (response: AxiosResponse<APIResponse, any>) => {
            // checkErrorCdoe(response);
            return response;
        },
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        (oError) => {
            console.log('error.response', oError.response); 
            if (showTips){
                const {error, msg} = oError.response?.data || {};
                const {t: $tFn} = useNuxtApp().$i18n;
                const message = error || msg || $tFn('commonInfo.requestError');
                showNegativeNotify({
                    message,
                });
            }
            return oError.response; 
        },
    );
    return api;
};


// export const privateApi = (subPath: string = '') => {
//     const api = axios.create({
//         baseURL: `${process.env.API_URL}/${subPath}`,
//         headers: { 'Content-Type': 'application/json' },
//         withCredentials: true,
//     });
//     // 👇请求拦截器
//     api.interceptors.request.use(
//         async (config) => {
//             const token = getTokenStorage();
//             if (config.headers) config.headers.authorization = `Bearer ${token.accessToken}`;
//             return config;
//         },
//         (error) => {
//             return Promise.reject(error);
//         },
//     );
//     // 👇响应拦截器
//     api.interceptors.response.use(
//         async (response: AxiosResponse<APIResponse, any>) => {
//             checkErrorCdoe(response);
//             return response;
//         },
//         async (error: AxiosError) => {
//             if (error.response) {
//                 // Access Token was expired
//                 if (error.response.status === 401) {
//                     const storedToken = getTokenStorage();
//                     try {
//                         const rs = await axios.post(
//                             `${process.env.API_URL}/auth/refresh`,
//                             {
//                                 refreshToken: storedToken.refreshToken,
//                             },
//                             {
//                                 headers: {
//                                     authorization: `Bearer ${storedToken.refreshToken}`,
//                                 },
//                             },
//                         );
//                         checkErrorCdoe(rs);
//                         setTokenStorage(rs.data.data);
//                         return api(error.config);
//                     } catch (_error: any) {
//                         console.log(_error);
//                         if (_error.response.status === 401) {
//                             cleanTokenStorage();
//                         }
//                         checkErrorCdoe(_error.response, _error.response.status);
//                         return Promise.reject(_error);
//                     }
//                 }
//             }
//             return Promise.reject(error);
//         },
//     );
//     return api;
// };

// async function checkErrorCdoe(response: AxiosResponse<APIResponse, any>, catchError: any = 'good') {
//     const { setDialogGate } = useAlertStore();
//     switch (response.data.status) {
//         case false:
//             setDialogGate(true);

//             break;

//         case true:
//             break;

//         default:
//             break;
//     }
// }
